import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/modal-confirmation/employment.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-12px"
}
const _hoisted_2 = { class: "text-lg font-semibold mb-4" }
const _hoisted_3 = { class: "lg:flex gap-4" }
const _hoisted_4 = { class: "lg:w-2/3" }
const _hoisted_5 = { class: "md:grid grid-cols-1 gap-8" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "flex align-items-center mt-4 col-span-2" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "invalid-feedback" }
const _hoisted_19 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { class: "invalid-feedback" }
const _hoisted_24 = { class: "lg:w-1/3" }
const _hoisted_25 = {
  class: "rounded-xl border-grey-4 p-4",
  style: {"height":"100%"}
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "flex items-center gap-2 border-bottom-grey-4 pb-2" }
const _hoisted_28 = { class: "text-base" }
const _hoisted_29 = { class: "md:w-1/2 text-sm text-grey" }
const _hoisted_30 = { class: "md:w-1/2 text-right text-sm" }
const _hoisted_31 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_32 = { class: "mt-4" }
const _hoisted_33 = { class: "md:grid grid-cols-2 gap-8" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "p-inputgroup" }
const _hoisted_36 = { class: "invalid-feedback" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = { class: "invalid-feedback" }
const _hoisted_39 = { class: "mt-60px" }
const _hoisted_40 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_41 = { class: "col-span-1 pt-6" }
const _hoisted_42 = { class: "icon-number float-right" }
const _hoisted_43 = { class: "icon_item mb-8" }
const _hoisted_44 = { class: "icon_circle" }
const _hoisted_45 = { class: "icon_number" }
const _hoisted_46 = { class: "col-span-2" }
const _hoisted_47 = { class: "mt-6 flex items-center" }
const _hoisted_48 = { class: "w-full rounded-lg border-grey-4 background-grey-3 py-8px px-16px" }
const _hoisted_49 = { class: "col-span-2" }
const _hoisted_50 = { class: "mt-6" }
const _hoisted_51 = { class: "" }
const _hoisted_52 = { class: "invalid-feedback" }
const _hoisted_53 = { class: "col-span-2" }
const _hoisted_54 = { class: "mt-6" }
const _hoisted_55 = { class: "" }
const _hoisted_56 = { class: "invalid-feedback" }
const _hoisted_57 = { class: "col-span-2" }
const _hoisted_58 = { class: "mt-6" }
const _hoisted_59 = { class: "" }
const _hoisted_60 = { class: "invalid-feedback" }
const _hoisted_61 = { class: "col-span-2" }
const _hoisted_62 = { class: "mt-6" }
const _hoisted_63 = { class: "flex gap-2" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "flex" }
const _hoisted_66 = { class: "flex-none" }
const _hoisted_67 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_68 = { class: "flex gap-1" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 1,
  class: "font-black truncate"
}
const _hoisted_71 = {
  key: 0,
  class: "flex gap-3 ml-2"
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "flex flex-col gap-1" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 2,
  class: "flex justify-between"
}
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "flex flex-col gap-1" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = {
  key: 1,
  class: "text-base font-normal text-grey mt-4"
}
const _hoisted_84 = { class: "mt-30px" }
const _hoisted_85 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_86 = { class: "col-span-1 pt-6" }
const _hoisted_87 = { class: "icon-number float-right" }
const _hoisted_88 = { class: "icon_item mb-8" }
const _hoisted_89 = { class: "icon_circle" }
const _hoisted_90 = { class: "icon_number" }
const _hoisted_91 = { class: "col-span-2" }
const _hoisted_92 = { class: "mt-6 flex items-center" }
const _hoisted_93 = { class: "w-full rounded-lg border-grey-4 background-grey-3 py-8px px-16px" }
const _hoisted_94 = { class: "col-span-2" }
const _hoisted_95 = { class: "mt-6" }
const _hoisted_96 = { class: "" }
const _hoisted_97 = { class: "invalid-feedback" }
const _hoisted_98 = { class: "col-span-2" }
const _hoisted_99 = { class: "mt-6" }
const _hoisted_100 = { class: "" }
const _hoisted_101 = { class: "invalid-feedback" }
const _hoisted_102 = { class: "col-span-2" }
const _hoisted_103 = { class: "mt-6" }
const _hoisted_104 = { class: "" }
const _hoisted_105 = { class: "invalid-feedback" }
const _hoisted_106 = { class: "col-span-2" }
const _hoisted_107 = { class: "mt-6" }
const _hoisted_108 = { class: "" }
const _hoisted_109 = { class: "flex" }
const _hoisted_110 = { class: "flex-none" }
const _hoisted_111 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_112 = {
  key: 1,
  class: "grid grid-cols-4 gap-1 py-2"
}
const _hoisted_113 = { class: "col-span-3" }
const _hoisted_114 = ["onClick"]
const _hoisted_115 = {
  key: 0,
  class: "col-span-1"
}
const _hoisted_116 = ["onClick"]
const _hoisted_117 = {
  key: 1,
  class: "text-base font-normal text-grey mt-4"
}
const _hoisted_118 = { class: "flex justify-end pt-16" }

import { ref, computed, onMounted, getCurrentInstance, reactive } from 'vue'
import { useStore } from 'vuex'
import { DatePicker } from 'v-calendar'
import * as Yup from 'yup'
import { Form, Field } from 'vee-validate'
import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import moment from 'moment'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import apiUseCase from '@/usecase/apiUseCase'
import apiImageUseCase from '@/usecase/apiImageUseCase'
import environment from '@/configs/environtment'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import numberFormat from '@/utils/helpers/numberFormat'
import Popper from 'vue3-popper'

const positionEndpoint = 'talent/v1/positions'
const employmentTypeEndpoint = 'talent/v1/employmentTypes'
const regionEndpoint = 'talent/v1/regions'
const employmentEndpoint = 'talent/v1/employments'
const assetEndpoint = 'api/v1/assets'
const employeeEndpoint = 'talent/v1/employees'
const buildingEndpoint = 'talent/v1/buildings'
const maxSizeFile = 1024 * 1024 * 1

// const contractData = computed(() => props.data)

export default /*@__PURE__*/_defineComponent({
  __name: 'EditContractForm',
  props: {
  id: {
    default: () => null as any
  }
},
  emits: ["onHideDialog", "reloadList"],
  setup(__props, { emit: __emit }) {

const emit = __emit
const title = ref('Tambah')
const payloadEmployment = ref()
const payloadSalaryEmployment = ref()
const employeeId = ref(null) as any
const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd, $confirm
} = app!.appContext.config.globalProperties
const props = __props
const idPrams = ref(props.id) as any
const selectForUpdateId = ref(null) as any
const contractData = ref()
const isLoading = ref(true)

const initialValues = ref({
  EmployeeId: null as any,
  Position: null as any,
  EmploymentType: null as any,
  Region: null as any,
  Building: null as any,
  StartDate: null as any,
  EndDate: null as any,
  Note: null as any,
  IsActive: true,
  BaseSalary: null as any,
  PaymentDay: null as any,
})

// const schema = Yup.object().shape({})
const schema = Yup.object().shape({
  Position: Yup.object()
    .required('Divisi wajib dipilih'),
  EmploymentType: Yup.object()
    .required('Jenis Kepegawaian wajib dipilih'),
  Region: Yup.object()
    .required('Wilayah Operasional wajib dipilih'),
  Building: Yup.object()
    .typeError('Gedung wajib dipilih')
    .required('Gedung wajib dipilih'),
  StartDate: Yup.string()
    .required('Tanggal Mulai wajib dipilih'),
  Note: Yup.string()
    .required('Keterangan wajib diisi'),
  BaseSalary: Yup.string()
    .nullable()
    // .required('Gaji per Bulan wajib diisi')
    .test('integer', 'Gaji per Bulan wajib berupa angka bulat', (value) => value == null || /^\d+$/.test(value) || value === '')
    .max(10, 'Gaji per Bulan maksimal 10 karakter'),
  PaymentDay: Yup.string()
    .nullable()
    // .required('Tanggal Pembayaran wajib diisi')
    .test('integer', 'Tanggal Pembayaran wajib berupa angka bulat', (value) => value == null || /^\d+$/.test(value) || value === '')
    // .test('not-zero', 'Tanggal Pembayaran tidak boleh 0', (value) => value == null || Number(value) > 0 || value === '')
    .test('max-day', 'Tanggal Pembayaran maksimal tanggal 31', (value) => value == null || Number(value) <= 31 || value === ''),
  // EndDate: Yup.date()
  //       .typeError('End Date is required')
  //       .required('End Date is required')
  //       .when('start_date', (StartDate) => {
  //           if (StartDate) {
  //               return Yup.date()
  //                   .min(StartDate, 'End Date must be after Start Date')
  //                   .typeError('End Date is required')
  //           }
  //       }),
})

const defaultPositionDocument = ref() as any
const employeeDocument = computed(() => store.getters['employee/getEmployeeDocuments'])
const positionRequiredDocuments = ref([]) as any
const positionRequiredDocumentsTemp = ref([]) as any
const additionalRequiredDocuments = ref([]) as any
const positionRequirementList = ref([]) as any

const defaultDocumentObj = ref({
  documentTypeId: '',
  documentTypeName: '',
  isRequired: false,
  documentNumber: null,
  issuedDate: null,
  expiredDate: null,
  fileUrl: null,
  remarks: ''
})

const reloadHeader = () => {
  emit('reloadList')
}

const onBack = () => {
  emit('onHideDialog')
}

const submitEmployeeSalary = async (contractId: string) => {
  try {
    const response = await apiUseCase.putWithNoId(`${employmentEndpoint}/${contractId}/salary`, payloadSalaryEmployment.value)
    if (!response.error) {
      $toast.add({
        severity: 'success',
        detail: 'Berhasil menyimpan Data Gaji Karyawan',
        group: 'bc',
        closable: false,
        life: 3000
      })
      // store.dispatch('employee/setEmployeeFormStep', 4)
    } else {
      let validationMessage = ''
      if (response.arrayMessage) {
        if (Array.isArray(response.arrayMessage['General.Validation']) && response.arrayMessage['General.Validation'].length > 0) {
          validationMessage = response.arrayMessage['General.Validation'].join('<br>')
        } else if (typeof response.arrayMessage === 'object') {
          validationMessage = Object.values(response.arrayMessage).flat().join('<br>')
        }
      }
      if (!validationMessage && response.message) {
        validationMessage = response.message
      }

      const isValidation = response.code === 400
        || Boolean(response.arrayMessage)
      const errorMsg = validationMessage || 'Gagal menyimpan Data Gaji Karyawan'
      $toast.add({
        severity: isValidation ? 'info' : 'error',
        detail: `Gaji Karyawan : ${errorMsg}`,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  } catch (error) {
    console.log('salarySubmitError', error)
    $toast.add({
      severity: 'error',
      detail: 'Gaji Karyawan : Gagal menyimpan Data Gaji Karyawan',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } finally {
    onBack()
    reloadHeader()
    store.dispatch('hideLoading')
  }
}

const processSubmitEmployment = async (shouldSubmitSalary = true) => {
  // console.log('payloadEmployment', payloadEmployment.value)
  await apiUseCase.postOrPut(employmentEndpoint, idPrams.value, payloadEmployment.value).then(async (response) => {
    console.log('response', response)
    const { error, arrayMessage } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data Kontrak Divisi berhasil diubah',
        group: 'bc',
        closable: false,
        life: 3000
      })
      if (shouldSubmitSalary) {
        await submitEmployeeSalary(contractData.value?.id ?? response.result.id)
      } else {
        onBack()
        reloadHeader()
      }
    } else {
      const errMsg = (arrayMessage && arrayMessage['General.Validation'])
        ? arrayMessage['General.Validation'].join('<br>')
        : (response.message || 'Data Kontrak Divisi gagal diubah')
      $toast.add({
        severity: 'error',
        summary: 'Data Kontrak Divisi gagal diubah',
        detail: errMsg,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
    store.dispatch('hideLoading')
  })
}

const formingEmploymentPayload = (values: any) => {
  // console.log('values', values)
  if (idPrams.value) {
    payloadEmployment.value = {
      id: idPrams.value,
      employeeId: store.getters['employee/getEmployeeId'],
      employmentTypeId: values.EmploymentType.value,
      positionId: values.Position.value,
      regionId: values.Region.value,
      buildingId: values.Building.id,
      startDate: moment(values.StartDate).format('YYYY-MM-DD'),
      // eslint-disable-next-line no-nested-ternary
      endDate: values.EndDate ? values.IsActive ? moment(values.EndDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD') : null,
      remarks: values.Note,
      isActive: values.IsActive
    }
  } else {
    payloadEmployment.value = {
      employeeId: store.getters['employee/getEmployeeId'],
      employmentTypeId: values.EmploymentType.value,
      positionId: values.Position.value,
      regionId: values.Region.value,
      buildingId: values.Building.id,
      startDate: values.StartDate ? moment(values.StartDate).format('YYYY-MM-DD') : null,
      // eslint-disable-next-line no-nested-ternary
      endDate: values.EndDate ? values.IsActive ? moment(values.EndDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD') : null,
      remarks: values.Note,
      isActive: values.IsActive
    }
  }
  payloadSalaryEmployment.value = {
    baseSalary: !values.BaseSalary || values.BaseSalary === '' ? 0 : Number(values.BaseSalary),
    paymentDay: !values.PaymentDay || values.PaymentDay === '' ? 0 : Number(values.PaymentDay)
  }
}

const getDocumentFileUrl = async (file: any) => {
  // console.log('file', file)
  const payload = new FormData()
  payload.append('file', file)
  // console.log('payload', payload)
  const response = await apiImageUseCase.postOrPut(assetEndpoint, null, payload)
  // console.log('response', response)
  if (!response.error) {
    return response.result.path
  }
  return null
}

const onSelectedDocumentRow = (id: any) => {
  selectForUpdateId.value = id
}

const onDocumentDateInput = (event: any, row: any, fieldKey: string) => {
  const val = event?.target?.value ?? event
  if (typeof val === 'string' && val.trim().length >= 8) {
    const parsed = moment(val.trim(), ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'], true)
    if (parsed.isValid()) {
      row[fieldKey] = parsed.toDate()
    }
  }
}

const onDocumentDateChange = (event: any, row: any, fieldKey: string) => {
  const val = event?.target?.value ?? event
  if (typeof val === 'string' && val.trim()) {
    const parsed = moment(val.trim(), ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'], true)
    if (parsed.isValid()) {
      row[fieldKey] = parsed.toDate()
    }
  } else if (!val) {
    row[fieldKey] = null
  }
}

const resetEdit = (index: any) => {
  selectForUpdateId.value = null
  // eslint-disable-next-line no-undef
  positionRequiredDocuments.value[index] = structuredClone(positionRequiredDocumentsTemp.value[index])
}

const processEditData = async (data: any, index: any) => {
  store.dispatch('showLoading')
  try {
    const imgUrl = data.documentFileUrl?.file ? await getDocumentFileUrl(data.documentFileUrl.file) : null

    const payload = {
      id: data.id,
      documentNumber: data.documentNumber,
      remarks: data.documentTypeName,
      fileUrl: imgUrl ? `${environment.getApiBaseImageUrl()}${imgUrl}` : (data.fileUrl ?? (typeof data.documentFileUrl === 'string' ? data.documentFileUrl : null)),
      issuedDate: data.issuedDate ? moment(data.issuedDate, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD') : null,
      expirationDate: data.expirationDate ? moment(data.expirationDate, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD') : null,
      documentTypeId: data.documentTypeId
    }

    await apiUseCase.putWithNoId(`${employeeEndpoint}/${employeeId.value}/documents/${data.id}`, payload).then((response) => {
      const { error, result } = response
      if (!error) {
        selectForUpdateId.value = null
        data.fileUrl = payload.fileUrl
        // eslint-disable-next-line no-undef
        positionRequiredDocumentsTemp.value[index] = structuredClone(positionRequiredDocuments.value[index])
        $toast.add({
          severity: 'success',
          detail: 'Dokumen berhasil diubah',
          group: 'bc',
          closable: false,
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        getEmployeeData()
      } else {
        let errMsg = 'Dokumen gagal diubah'
        if (response.arrayMessage && typeof response.arrayMessage === 'object') {
          errMsg = Object.values(response.arrayMessage).flat().join('<br>')
        } else if (response.message) {
          errMsg = response.message
        }
        $toast.add({
          severity: 'error',
          detail: errMsg,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      detail: 'Dokumen gagal diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onSubmitEdit = (data: any, index: any) => {
  $confirm.require({
    header: 'Edit Data Dokumen',
    message: 'Apakah anda yakin ingin menggantinya?',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      processEditData(data, index)
    }
  })
}

const processAddData = async (data: any, index: any) => {
  store.dispatch('showLoading')
  try {
    const imgUrl = data.documentFileUrl?.file ? await getDocumentFileUrl(data.documentFileUrl.file) : null

    const payload = {
      documentNumber: data.documentNumber,
      remarks: data.documentTypeName,
      fileUrl: imgUrl ? `${environment.getApiBaseImageUrl()}${imgUrl}` : (data.fileUrl ?? (typeof data.documentFileUrl === 'string' ? data.documentFileUrl : null)),
      issuedDate: data.issuedDate ? moment(data.issuedDate, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD') : null,
      expirationDate: data.expirationDate ? moment(data.expirationDate, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD') : null,
      documentTypeId: data.documentTypeId
    }

    await apiUseCase.postOrPut(`${employeeEndpoint}/${employeeId.value}/documents`, null, payload).then((response) => {
      const { error, result } = response
      if (!error) {
        data.id = result?.id ?? result
        data.fileUrl = payload.fileUrl
        // eslint-disable-next-line no-undef
        positionRequiredDocumentsTemp.value[index] = structuredClone(positionRequiredDocuments.value[index])
        $toast.add({
          severity: 'success',
          detail: 'Dokumen berhasil ditambahkan',
          group: 'bc',
          closable: false,
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        getEmployeeData()
      } else {
        let errMsg = 'Dokumen gagal ditambahkan'
        if (response.arrayMessage && typeof response.arrayMessage === 'object') {
          errMsg = Object.values(response.arrayMessage).flat().join('<br>')
        } else if (response.message) {
          errMsg = response.message
        }
        $toast.add({
          severity: 'error',
          detail: errMsg,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      detail: 'Dokumen gagal ditambahkan',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onSubmitAdd = (data: any, index: any) => {
  $confirm.require({
    header: 'Simpan Data Dokumen',
    message: 'Apakah anda yakin ingin menyimpan dokumen ini?',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      processAddData(data, index)
    }
  })
}

const isContractChanged = (values: any) => {
  const getId = (item: any) => {
    if (!item) return null
    if (typeof item === 'object') {
      return item.value ?? item.id ?? null
    }
    return item
  }

  const formatDate = (date: any) => (date ? moment(date).format('YYYY-MM-DD') : null)

  const isPositionChanged = getId(values.Position) !== getId(initialValues.value.Position)
  const isEmploymentTypeChanged = getId(values.EmploymentType) !== getId(initialValues.value.EmploymentType)
  const isRegionChanged = getId(values.Region) !== getId(initialValues.value.Region)
  const isBuildingChanged = getId(values.Building) !== getId(initialValues.value.Building)
  const isStartDateChanged = formatDate(values.StartDate) !== formatDate(initialValues.value.StartDate)
  const isEndDateChanged = formatDate(values.EndDate) !== formatDate(initialValues.value.EndDate)
  const isIsActiveChanged = Boolean(values.IsActive) !== Boolean(initialValues.value.IsActive)
  const isNoteChanged = String(values.Note ?? '').trim() !== String(initialValues.value.Note ?? '').trim()

  return (
    isPositionChanged
    || isEmploymentTypeChanged
    || isRegionChanged
    || isBuildingChanged
    || isStartDateChanged
    || isEndDateChanged
    || isIsActiveChanged
    || isNoteChanged
  )
}

const isSalaryChanged = (values: any) => {
  const isBaseSalaryChanged = Number(values.BaseSalary || 0) !== Number(initialValues.value.BaseSalary || 0)
  const isPaymentDayChanged = Number(values.PaymentDay || 0) !== Number(initialValues.value.PaymentDay || 0)
  return isBaseSalaryChanged || isPaymentDayChanged
}

const onSubmit = async (values: any) => {
  store.dispatch('showLoading')

  if (selectForUpdateId.value) {
    const updateIndex = positionRequiredDocuments.value.findIndex((d: any) => d.id === selectForUpdateId.value)
    if (updateIndex !== -1) {
      await processEditData(positionRequiredDocuments.value[updateIndex], updateIndex)
    }
  }

  const pendingDocs = positionRequiredDocuments.value
    .map((doc: any, i: number) => ({ doc, i }))
    .filter(({ doc }: any) => !doc.id && (doc.documentNumber || doc.issuedDate || doc.documentFileUrl))

  await Promise.all(pendingDocs.map(({ doc, i }: any) => processAddData(doc, i)))

  formingEmploymentPayload(values)

  const contractChanged = isContractChanged(values)
  const salaryChanged = isSalaryChanged(values)

  if (contractChanged) {
    await processSubmitEmployment(salaryChanged)
  } else if (salaryChanged) {
    await submitEmployeeSalary(contractData.value?.id ?? idPrams.value)
  } else {
    onBack()
    reloadHeader()
    store.dispatch('hideLoading')
  }
}

const defineInitialValues = () => {
  initialValues.value.Position = { label: contractData.value.positionName, value: contractData.value.positionId, name: contractData.value.positionName, code: contractData.value.positionCode }
  initialValues.value.EmploymentType = { label: contractData.value.employmentTypeName, value: contractData.value.employmentTypeId }
  initialValues.value.Region = { label: contractData.value.regionName, value: contractData.value.regionId }
  initialValues.value.Building = contractData.value.buildingId ? { label: contractData.value.buildingName, value: contractData.value.buildingId, id: contractData.value.buildingId } : null
  initialValues.value.StartDate = contractData.value.startDate ? moment(contractData.value.startDate).format('YYYY-MM-DD') : null
  initialValues.value.EndDate = contractData.value.endDate ? moment(contractData.value.endDate).format('YYYY-MM-DD') : null
  initialValues.value.Note = contractData.value.remarks
  initialValues.value.BaseSalary = contractData.value.salary?.baseSalary
  initialValues.value.PaymentDay = contractData.value.salary?.paymentDay
  if (contractData.value.IsActive || !contractData.value.endDate) {
    initialValues.value.IsActive = true
  } else {
    initialValues.value.IsActive = false
  }
  // eslint-disable-next-line no-use-before-define
  getPositionDetail(contractData.value.positionId)
  isLoading.value = false
}

const getEmployeeData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${employeeId.value}`).then((response) => {
    const { error, result } = response
    if (!error) {
      store.dispatch('employee/setEmployeeData', result)
      // eslint-disable-next-line no-use-before-define
      getPositionDetail(contractData.value.positionId)
    } else {
      console.log('error', error)
    }
  })
  store.dispatch('hideLoading')
}

const getData = async () => {
  await apiUseCase.get(`${employmentEndpoint}/${idPrams.value}`).then((response) => {
    const { error, result } = response
    if (!error) {
      contractData.value = result
      // console.log('contractData', contractData.value)
      // console.log('store', store.state)
      defineInitialValues()
    }
  })
}

const defineRequiredDocuments = () => {
  positionRequiredDocuments.value = []
  positionRequiredDocuments.value = defaultPositionDocument.value.map((dataA: any) => {
    const match = employeeDocument.value.find((dataB: any) => dataB.documentTypeId === dataA.documentTypeId)
    if (match) {
      return {
        ...match,
        isRequired: dataA.isRequired,
        remarks: '',
        fileUrl: match.fileUrl ?? match.documentFileUrl ?? null,
        documentFileUrl: match.fileUrl ?? match.documentFileUrl ?? null
      }
    }
    // console.log('dataA', dataA)
    return {
      id: null,
      documentTypeId: dataA.documentTypeId,
      documentTypeName: dataA.documentTypeName,
      isRequired: dataA.isRequired,
      documentNumber: null,
      issuedDate: null,
      expirationDate: null,
      documentFileUrl: null,
      remarks: ''
    }
  })
  // eslint-disable-next-line no-undef
  positionRequiredDocumentsTemp.value = structuredClone(positionRequiredDocuments.value)
  // console.log('positionRequiredDocumentsTemp', positionRequiredDocumentsTemp.value)
}

const defineAdditionalDocuments = () => {
  additionalRequiredDocuments.value = []
  const tempPosReqDoc = positionRequiredDocuments.value.map((data: any) => data.documentTypeId)
  additionalRequiredDocuments.value = employeeDocument.value.filter((data: any) => !tempPosReqDoc.includes(data.documentTypeId))
  // console.log('additionalRequiredDocuments', additionalRequiredDocuments.value)
}

const getPositionDetail = async (idPosition: string) => {
  store.dispatch('showLoading')
  try {
    await apiUseCase.get(`${positionEndpoint}/${idPosition}/documentRequirements`).then((response) => {
      const { error, result } = response
      if (!error) {
        console.log('res', result)
        defaultPositionDocument.value = result
        defineRequiredDocuments()
        defineAdditionalDocuments()
      } else {
        console.log('error')
      }
    })
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const getPositionRequirements = async (idPosition: string) => {
  store.dispatch('showLoading')
  try {
    positionRequirementList.value = []
    await apiUseCase.get(`${positionEndpoint}/${idPosition}/requirements`).then((response) => {
      const { error, result } = response
      if (!error) {
        // console.log('resDocReq', result)
        positionRequirementList.value = result
      } else {
        console.log('error')
      }
    })
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const onSelectedPosition = (data: any) => {
  getPositionDetail(data.id)
  getPositionRequirements(data.id)
}

const onNumericInput = (event: Event, field: any, maxLength: number) => {
  const input = event.target as HTMLInputElement
  input.value = input.value.replace(/\D/g, '').slice(0, maxLength)
  field.onInput(event)
}

const onInputFile = (file: any, typeUpload: any, setFieldValue: any, x: any) => {
  /* eslint-disable */
  if (file) {
    const totalSize: number = Number((file.size / 1024 / 1024).toFixed(1))
    if (totalSize > 1) {
      $toast.add({
        severity: 'error',
        detail: 'Ukuran file lebih dari 1MB.',
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      /* eslint-disable-next-line */
      // console.log('typeUpload', typeUpload)
      if (file) {
        x.documentFileUrl = { file: file.file, name: file.name, blob: file.blob }
      }
    }
  }
}

const openDetailImg = (fileUrl: any) => {
  window.open(fileUrl?.blob ? fileUrl?.blob : fileUrl, '_blank')
}

const processDeleteDocument = async (data: any, index: any) => {
  store.dispatch('showLoading')
  await apiUseCase.delete(`${employeeEndpoint}/${employeeId.value}/documents`, data?.id). then((response) => {
    const { error } = response
    if (!error) {
      positionRequiredDocuments[index] = {
        id: null,
        documentTypeId: data.documentTypeId,
        documentTypeName: data.documentTypeName,
        isRequired: data.isRequired,
        documentNumber: null,
        issuedDate: null,
        expirationDate: null,
        documentFileUrl: null,
        remarks: ''
      }
      getEmployeeData()
      $toast.add({
        severity: 'success',
        detail: 'Dokumen berhasil dihapus',
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Dokumen gagal dihapus',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onDeleteDocument = (data: any, index: any) => {
  $confirm.require({
    header: 'Hapus Data Dokumen',
    message: 'Apakah anda yakin ingin menghapusnya?',
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      processDeleteDocument(data, index)
    }
  })
}

const check = (val: any, setFieldValue: any) => {
  // console.log('check', [val])
  setFieldValue('IsActive', !val)
}


const shortenFileName = (fileName: string) => {
  let sliced = fileName.slice(0, 20)
  return `${sliced}...`
}

onMounted(() => {
  employeeId.value = store.getters['employee/getEmployeeId']
  if (idPrams.value) {
    title.value = 'Edit'
    getData()
  } else {
    isLoading.value = false
  }
  // console.log('employeeDocuments', employeeDocument.value)
})

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(`${title.value} Kontrak Divisi`), 1),
        _createVNode(_unref(Form), {
          onSubmit: onSubmit,
          "validation-schema": _unref(schema),
          "initial-values": initialValues.value,
          class: "form-container"
        }, {
          default: _withCtx(({ errors, setFieldValue, values, meta }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", {
                      for: "position",
                      class: "label-text required"
                    }, "Divisi", -1)),
                    _createVNode(_unref(Field), {
                      id: "position",
                      name: "Position",
                      class: _normalizeClass(`input-primary ${errors.LastEducation ? 'input-invalid' : ''}`),
                      validateOnInput: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectAsync, {
                          modelValue: values.Position,
                          "onUpdate:modelValue": [($event: any) => ((values.Position) = $event), (val) => setFieldValue(`Position`, val)],
                          inputId: `position`,
                          endpoint: positionEndpoint,
                          fieldLabel: (v) => `${v.name}`,
                          fieldValue: 'id',
                          clearable: false,
                          searchFields: ['name'],
                          placeholder: `Pilih Divisi`,
                          classname: 'custom-select',
                          onChange: _cache[0] || (_cache[0] = (val) => onSelectedPosition(val))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(errors.Position), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", {
                      for: "region",
                      class: "label-text required"
                    }, "Wilayah Operasional", -1)),
                    _createVNode(_unref(Field), {
                      id: "region",
                      name: "Region",
                      class: _normalizeClass(`input-primary ${errors.Region ? 'input-invalid' : ''}`),
                      validateOnInput: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectAsync, {
                          modelValue: values.Region,
                          "onUpdate:modelValue": [($event: any) => ((values.Region) = $event), (val) => setFieldValue(`Region`, val)],
                          inputId: `region`,
                          endpoint: regionEndpoint,
                          fieldLabel: (v) => `${v.name}`,
                          fieldValue: 'id',
                          clearable: false,
                          searchFields: ['name'],
                          placeholder: `Pilih wilayah operasional`,
                          classname: 'custom-select'
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(errors.Region), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", {
                      for: "employmentType",
                      class: "label-text required"
                    }, "Jenis Kepegawaian", -1)),
                    _createVNode(_unref(Field), {
                      id: "employmentType",
                      name: "EmploymentType",
                      class: _normalizeClass(`input-primary ${errors.EmploymentType ? 'input-invalid' : ''}`),
                      validateOnInput: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectAsync, {
                          modelValue: values.EmploymentType,
                          "onUpdate:modelValue": [($event: any) => ((values.EmploymentType) = $event), (val) => setFieldValue(`EmploymentType`, val)],
                          inputId: `employmentType`,
                          endpoint: employmentTypeEndpoint,
                          fieldLabel: (v) => `${v.name}`,
                          fieldValue: 'id',
                          clearable: false,
                          searchFields: ['name'],
                          placeholder: `Pilih jenis kepegawaian`,
                          classname: 'custom-select'
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(errors.EmploymentType), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        for: "startDate",
                        class: "label-text required"
                      }, "Tanggal Mulai", -1)),
                      _createVNode(_unref(Field), { name: "StartDate" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_unref(DatePicker), _mergeProps(field, {
                            modelValue: values.StartDate,
                            "onUpdate:modelValue": [($event: any) => ((values.StartDate) = $event), (val) => setFieldValue('StartDate', val)],
                            masks: {
                      input: 'DD/MM/YYYY'
                    }
                          }), {
                            default: _withCtx(({ togglePopover, inputValue }) => [
                              _createVNode(_unref(InputText), {
                                id: "startDate",
                                "aria-describedby": "startDate-help",
                                placeholder: "DD/MM/YYYY",
                                value: inputValue,
                                class: _normalizeClass(`input-primary ${errors.StartDate ? 'input-invalid' : ''}`),
                                onClick: togglePopover
                              }, null, 8, ["value", "class", "onClick"])
                            ]),
                            _: 2
                          }, 1040, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(errors.StartDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_unref(Checkbox), {
                        modelValue: values.IsActive,
                        "onUpdate:modelValue": [($event: any) => ((values.IsActive) = $event), (val) => val ? setFieldValue('EndDate', null) : ''],
                        inputId: "IsEmployeeActive",
                        binary: true,
                        onChange: (val) => check(values.IsActive, setFieldValue)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "IsEmployeeActive",
                        class: "ml-2"
                      }, "Kontrak Karyawan masih aktif", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        for: "endDate",
                        class: "label-text"
                      }, "Tanggal Selesai", -1)),
                      _createVNode(_unref(Field), { name: "EndDate" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_unref(DatePicker), _mergeProps(field, {
                            modelValue: values.EndDate,
                            "onUpdate:modelValue": [($event: any) => ((values.EndDate) = $event), (val) => val ? values.IsActive=false : ''],
                            disabled: values.IsActive,
                            masks: {
                      input: 'DD/MM/YYYY'
                    }
                          }), {
                            default: _withCtx(({ togglePopover, inputValue }) => [
                              _createVNode(_unref(InputText), {
                                id: "endDate",
                                "aria-describedby": "endDate-help",
                                placeholder: "DD/MM/YYYY",
                                value: inputValue,
                                class: _normalizeClass(`input-primary ${errors.EndDate ? 'input-invalid' : ''}`),
                                onClick: togglePopover,
                                disabled: values.IsActive
                              }, null, 8, ["value", "class", "onClick", "disabled"])
                            ]),
                            _: 2
                          }, 1040, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(errors.EndDate), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", {
                      for: "building",
                      class: "label-text required"
                    }, "Kantor Kerja", -1)),
                    _createVNode(_unref(Field), {
                      id: "building",
                      name: "Building",
                      class: _normalizeClass(`input-primary ${errors.building ? 'input-invalid' : ''}`),
                      validateOnInput: true
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(SelectAsync, _mergeProps(field, {
                          inputId: `building`,
                          endpoint: `${buildingEndpoint}`,
                          fieldLabel: (v) => `${v.name}`,
                          modelValue: values.Building,
                          clearable: true,
                          searchFields: ['name'],
                          placeholder: `Pilih Gedung`,
                          classname: 'custom-select',
                          disabled: false,
                          "search-custom": [['isActive', '=', 'true']]
                        }), null, 16, ["endpoint", "fieldLabel", "modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["class"]),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(errors.Building), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", {
                      for: "note",
                      class: "label-text required"
                    }, "Keterangan", -1)),
                    _createVNode(_unref(Field), {
                      id: "note",
                      name: "Note",
                      as: "textarea",
                      type: "text",
                      placeholder: "Ex. Jl. Harapan Blok J4-Y4, Tulungagung",
                      class: "input-primary",
                      modelValue: values.Note,
                      "onUpdate:modelValue": ($event: any) => ((values.Note) = $event),
                      validateOnInput: true,
                      rows: "5"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(errors.Note), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (values.Position)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-base text-grey" }, "Divisi:", -1)),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(values.Position?.name ?? values.Position?.value) + " " + _toDisplayString(`(${values.Position?.code})`), 1)
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "font-semibold text-base mt-3" }, "Persyaratan Umum", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positionRequirementList.value, (data) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: data,
                            class: "md:flex gap-4 mt-2"
                          }, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(data.requirementName), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(data.requirementDataType === 'Integer' ? _unref(numberFormat)(data.dataValue) : data.dataValue), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[12] || (_cache[12] = [
                        _createElementVNode("div", { class: "text-center w-2/3" }, [
                          _createElementVNode("img", {
                            class: "mx-auto",
                            src: _imports_0,
                            alt: "position"
                          }),
                          _createElementVNode("div", { class: "text-xl font-semibold" }, "Persyaratan Umum"),
                          _createElementVNode("div", { class: "text-sm text-grey" }, "Pilih Divisi untuk menampilkan informasi persyaratan umum dari Divisi tersebut")
                        ], -1)
                      ])))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    for: "baseSalary",
                    class: "label-text"
                  }, "Gaji per Bulan", -1)),
                  _createVNode(_unref(Field), {
                    id: "baseSalary",
                    name: "BaseSalary",
                    class: _normalizeClass(`input-primary ${errors.BaseSalary ? 'input-invalid' : ''}`),
                    validateOnInput: true
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "p-inputgroup-addon" }, _toDisplayString('Rp.'), -1)),
                        _createVNode(_unref(InputText), _mergeProps({
                          class: `input-primary ${errors.BaseSalary ? 'input-invalid' : ''}`,
                          id: "baseSalary"
                        }, field, {
                          "aria-describedby": "base-salary-help",
                          placeholder: "0",
                          type: "text",
                          inputmode: "numeric",
                          maxlength: "10",
                          onInput: (event) => onNumericInput(event, field, 10)
                        }), null, 16, ["class", "onInput"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createElementVNode("div", _hoisted_36, _toDisplayString(errors.BaseSalary), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", {
                    for: "paymentDay",
                    class: "label-text"
                  }, "Tanggal Pembayaran per Bulan", -1)),
                  _createVNode(_unref(Field), {
                    id: "paymentDay",
                    name: "PaymentDay",
                    class: _normalizeClass(`input-primary ${errors.PaymentDay ? 'input-invalid' : ''}`),
                    validateOnInput: true
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_unref(InputText), _mergeProps({
                        class: `input-primary ${errors.PaymentDay ? 'input-invalid' : ''}`,
                        id: "paymentDay"
                      }, field, {
                        "aria-describedby": "payment-day-help",
                        placeholder: "0",
                        type: "text",
                        inputmode: "numeric",
                        maxlength: "2",
                        onInput: (event) => onNumericInput(event, field, 2)
                      }), null, 16, ["class", "onInput"])
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(errors.PaymentDay), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", null, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-lg font-bold" }, "Dokumen Penting", -1)),
                (positionRequiredDocuments.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "grid grid-cols-11 gap-8 ml-min" }, [
                        _createElementVNode("div", { class: "col-span-1 pt-6" }),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Tipe Dokumen")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Nomor Dokumen")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Tanggal Dikeluarkan")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Berlaku Sampai")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "File Dokumen")
                        ])
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positionRequiredDocuments.value, (x, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "grid grid-cols-11 gap-8 ml-min",
                          key: i
                        }, [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mt-1" }, null, -1)),
                            _createElementVNode("ul", _hoisted_42, [
                              _createElementVNode("li", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("p", _hoisted_45, _toDisplayString(i + 1), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(x.isRequired ? 'required' : '')
                                }, _toDisplayString(x.documentTypeName), 3)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_unref(InputText), {
                                  id: "KTPdocNumber",
                                  "aria-describedby": "id-ktpdocnumber-help",
                                  placeholder: "1234xxx",
                                  class: _normalizeClass(`input-primary ${x.errorDocumentNumber ? 'input-invalid' : ''}`),
                                  modelValue: x.documentNumber,
                                  "onUpdate:modelValue": ($event: any) => ((x.documentNumber) = $event),
                                  readonly: Boolean(x.id && selectForUpdateId.value !== x.id)
                                }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "readonly"]),
                                _createElementVNode("div", _hoisted_52, _toDisplayString(x.errorDocumentNumber), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_unref(DatePicker), {
                                  modelValue: x.issuedDate,
                                  "onUpdate:modelValue": ($event: any) => ((x.issuedDate) = $event),
                                  masks: {
                        input: 'DD/MM/YYYY'
                      },
                                  "input-debounce": 0
                                }, {
                                  default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                                    _createVNode(_unref(InputText), _mergeProps({
                                      id: "KTPIssuedDate",
                                      "aria-describedby": "ktp-issuedDate-help",
                                      placeholder: "DD/MM/YYYY",
                                      value: inputValue,
                                      class: `input-primary ${x.errorIssuedDate ? 'input-invalid' : ''}`
                                    }, _toHandlers((!x.id || selectForUpdateId.value === x.id) ? inputEvents : {}), {
                                      onClick: ($event: any) => ((!x.id || selectForUpdateId.value === x.id) && togglePopover()),
                                      onInput: (e) => (!x.id || selectForUpdateId.value === x.id) && onDocumentDateInput(e, x, 'issuedDate'),
                                      onChange: (e) => (!x.id || selectForUpdateId.value === x.id) && onDocumentDateChange(e, x, 'issuedDate'),
                                      readonly: Boolean(x.id && selectForUpdateId.value !== x.id)
                                    }), null, 16, ["value", "class", "onClick", "onInput", "onChange", "readonly"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("div", _hoisted_56, _toDisplayString(x.errorIssuedDate), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_unref(DatePicker), {
                                  modelValue: x.expirationDate,
                                  "onUpdate:modelValue": ($event: any) => ((x.expirationDate) = $event),
                                  masks: {
                        input: 'DD/MM/YYYY'
                      },
                                  "input-debounce": 0
                                }, {
                                  default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                                    _createVNode(_unref(InputText), _mergeProps({
                                      id: "KTPExpirationDate",
                                      "aria-describedby": "ktp-expirationDate-help",
                                      placeholder: "DD/MM/YYYY",
                                      value: inputValue,
                                      class: `input-primary ${x.errorExpirationDate ? 'input-invalid' : ''}`
                                    }, _toHandlers((!x.id || selectForUpdateId.value === x.id) ? inputEvents : {}), {
                                      onClick: ($event: any) => ((!x.id || selectForUpdateId.value === x.id) && togglePopover()),
                                      onInput: (e) => (!x.id || selectForUpdateId.value === x.id) && onDocumentDateInput(e, x, 'expirationDate'),
                                      onChange: (e) => (!x.id || selectForUpdateId.value === x.id) && onDocumentDateChange(e, x, 'expirationDate'),
                                      readonly: Boolean(x.id && selectForUpdateId.value !== x.id)
                                    }), null, 16, ["value", "class", "onClick", "onInput", "onChange", "readonly"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("div", _hoisted_60, _toDisplayString(x.errorExpirationDate), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                (selectForUpdateId.value && selectForUpdateId.value === x.id || !x.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                      _createVNode(ButtonFileUpload, {
                                        inputId: `KTPFileDocument-${i}`,
                                        size: maxSizeFile,
                                        modelValue: x.documentFileUrl,
                                        "onUpdate:modelValue": ($event: any) => ((x.documentFileUrl) = $event),
                                        onOnInputFile: (newFile, oldFile) => onInputFile(newFile, x.documentTypeName, setFieldValue, x)
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_65, [
                                            _createElementVNode("div", _hoisted_66, [
                                              (!x.documentFileUrl)
                                                ? (_openBlock(), _createBlock(_unref(Button), {
                                                    key: 0,
                                                    class: "btn-back flex gap-x-2 cursor cursor-pointer",
                                                    modelValue: x.documentFileUrl,
                                                    "onUpdate:modelValue": ($event: any) => ((x.documentFileUrl) = $event)
                                                  }, {
                                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                      _createElementVNode("i", { class: "pi pi-upload font-black text-sm" }, null, -1),
                                                      _createTextVNode(" Browse")
                                                    ])),
                                                    _: 2,
                                                    __: [17]
                                                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["inputId", "modelValue", "onUpdate:modelValue", "onOnInputFile"]),
                                      (!x.documentFileUrl)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(x.errorDocumentFile), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("div", null, [
                                    (x.documentFileUrl)
                                      ? (_openBlock(), _createElementBlock("p", {
                                          key: 0,
                                          class: "font-black truncate cursor-pointer",
                                          onClick: ($event: any) => (openDetailImg(x.documentFileUrl))
                                        }, _toDisplayString(x.documentFileUrl.name ? shortenFileName(x.documentFileUrl.name) : shortenFileName(x.documentFileUrl)), 9, _hoisted_69))
                                      : ((!x?.documentFileUrl && !selectForUpdateId.value) && x.id || ( x.id && selectForUpdateId.value != x.id ))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_70, "Tidak Ada"))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", null, [
                                    (x.id && selectForUpdateId.value !== x.id)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                          _createVNode(_unref(Popper), {
                                            arrow: "",
                                            hover: "",
                                            placement: "bottom",
                                            content: "Edit Data Dokumen"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("i", {
                                                class: "pi pi-pencil font-bold text-sm cursor-pointer",
                                                onClick: ($event: any) => (onSelectedDocumentRow(x.id))
                                              }, null, 8, _hoisted_72)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_unref(Popper), {
                                            arrow: "",
                                            hover: "",
                                            placement: "bottom",
                                            content: "Hapus Data Dokumen"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("i", {
                                                class: "pi pi-trash font-bold color-danger text-sm cursor-pointer",
                                                onClick: ($event: any) => (onDeleteDocument(x, i))
                                              }, null, 8, _hoisted_73)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      : (x.id && selectForUpdateId.value === x.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                            _createVNode(_unref(Popper), {
                                              arrow: "",
                                              hover: "",
                                              placement: "bottom",
                                              content: "Hapus File Dokumen"
                                            }, {
                                              default: _withCtx(() => [
                                                (x.documentFileUrl)
                                                  ? (_openBlock(), _createElementBlock("i", {
                                                      key: 0,
                                                      class: "pi pi-times font-bold color-danger text-sm cursor-pointer mr-2",
                                                      onClick: ($event: any) => (x.documentFileUrl = '')
                                                    }, null, 8, _hoisted_75))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createElementVNode("div", _hoisted_76, [
                                              _createElementVNode("div", {
                                                class: "cursor-pointer background-success text-white p-2 rounded-lg text-center font-bold",
                                                onClick: ($event: any) => (onSubmitEdit(x, i))
                                              }, "Simpan", 8, _hoisted_77),
                                              _createElementVNode("div", {
                                                class: "cursor-pointer text-center background-danger text-white p-2 rounded-lg text-center font-bold",
                                                onClick: ($event: any) => (resetEdit(i))
                                              }, "Batal", 8, _hoisted_78)
                                            ])
                                          ]))
                                        : (!x.id)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                              _createVNode(_unref(Popper), {
                                                arrow: "",
                                                hover: "",
                                                placement: "bottom",
                                                content: "Hapus File Dokumen"
                                              }, {
                                                default: _withCtx(() => [
                                                  (x.documentFileUrl)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 0,
                                                        class: "pi pi-times font-bold color-danger text-sm cursor-pointer mr-2",
                                                        onClick: ($event: any) => (x.documentFileUrl = '')
                                                      }, null, 8, _hoisted_80))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createElementVNode("div", _hoisted_81, [
                                                _createElementVNode("div", {
                                                  class: "cursor-pointer background-success text-white p-2 rounded-lg text-center font-bold",
                                                  onClick: ($event: any) => (onSubmitAdd(x, i))
                                                }, "Simpan", 8, _hoisted_82)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_83, "Pilih Divisi untuk mengetahui dokumen apa saja yang perlu Anda masukkan!"))
              ]),
              _createElementVNode("div", _hoisted_84, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-lg font-bold" }, "Dokumen Syarat Tambahan", -1)),
                (additionalRequiredDocuments.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "grid grid-cols-11 gap-8 ml-min" }, [
                        _createElementVNode("div", { class: "col-span-1 pt-6" }),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Tipe Dokumen")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Nomor Dokumen")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Tanggal Dikeluarkan")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "Berlaku Sampai")
                        ]),
                        _createElementVNode("div", { class: "col-span-2" }, [
                          _createElementVNode("p", { class: "text-base" }, "File Dokumen")
                        ])
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(additionalRequiredDocuments.value, (x, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "grid grid-cols-11 gap-8 ml-min",
                          key: i
                        }, [
                          _createElementVNode("div", _hoisted_86, [
                            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-1" }, null, -1)),
                            _createElementVNode("ul", _hoisted_87, [
                              _createElementVNode("li", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("p", _hoisted_90, _toDisplayString(i + 1), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("div", null, _toDisplayString(x.documentTypeName), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _createVNode(_unref(InputText), {
                                  id: "KTPdocNumber",
                                  "aria-describedby": "id-ktpdocnumber-help",
                                  placeholder: "1234xxx",
                                  class: _normalizeClass(`input-primary ${x.errorDocumentNumber ? 'input-invalid' : ''}`),
                                  modelValue: x.documentNumber,
                                  "onUpdate:modelValue": ($event: any) => ((x.documentNumber) = $event)
                                }, null, 8, ["class", "modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("div", _hoisted_97, _toDisplayString(x.errorDocumentNumber), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createElementVNode("div", _hoisted_100, [
                                _createVNode(_unref(DatePicker), {
                                  modelValue: x.issuedDate,
                                  "onUpdate:modelValue": ($event: any) => ((x.issuedDate) = $event),
                                  masks: {
                        input: 'DD/MM/YYYY'
                      }
                                }, {
                                  default: _withCtx(({ togglePopover, inputValue }) => [
                                    _createVNode(_unref(InputText), {
                                      id: "KTPIssuedDate",
                                      "aria-describedby": "ktp-issuedDate-help",
                                      placeholder: "DD/MM/YYYY",
                                      value: inputValue,
                                      class: _normalizeClass(`input-primary ${x.errorIssuedDate ? 'input-invalid' : ''}`),
                                      onClick: togglePopover,
                                      readonly: ""
                                    }, null, 8, ["value", "class", "onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("div", _hoisted_101, _toDisplayString(x.errorIssuedDate), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("div", _hoisted_104, [
                                _createVNode(_unref(DatePicker), {
                                  modelValue: x.expirationDate,
                                  "onUpdate:modelValue": ($event: any) => ((x.expirationDate) = $event),
                                  masks: {
                        input: 'DD/MM/YYYY'
                      }
                                }, {
                                  default: _withCtx(({ togglePopover, inputValue }) => [
                                    _createVNode(_unref(InputText), {
                                      id: "KTPExpirationDate",
                                      "aria-describedby": "ktp-expirationDate-help",
                                      placeholder: "DD/MM/YYYY",
                                      value: inputValue,
                                      class: _normalizeClass(`input-primary ${x.errorExpirationDate ? 'input-invalid' : ''}`),
                                      onClick: togglePopover,
                                      readonly: ""
                                    }, null, 8, ["value", "class", "onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("div", _hoisted_105, _toDisplayString(x.errorExpirationDate), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("div", _hoisted_107, [
                              _createElementVNode("div", _hoisted_108, [
                                _createVNode(ButtonFileUpload, {
                                  inputId: `KTPFileDocument-${i}`,
                                  size: maxSizeFile,
                                  modelValue: x.documentFileUrl,
                                  "onUpdate:modelValue": ($event: any) => ((x.documentFileUrl) = $event),
                                  onOnInputFile: (newFile, oldFile) => onInputFile(newFile, x.documentTypeName, setFieldValue, x)
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_109, [
                                      _createElementVNode("div", _hoisted_110, [
                                        (!x.documentFileUrl)
                                          ? (_openBlock(), _createBlock(_unref(Button), {
                                              key: 0,
                                              class: "btn-back flex gap-x-2 cursor cursor-pointer",
                                              modelValue: x.documentFileUrl,
                                              "onUpdate:modelValue": ($event: any) => ((x.documentFileUrl) = $event)
                                            }, {
                                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                _createElementVNode("i", { class: "pi pi-upload font-black text-sm" }, null, -1),
                                                _createTextVNode(" Browse")
                                              ])),
                                              _: 2,
                                              __: [21]
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["inputId", "modelValue", "onUpdate:modelValue", "onOnInputFile"]),
                                (!x.documentFileUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString(x.errorDocumentFile), 1))
                                  : _createCommentVNode("", true),
                                (x.documentFileUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                      _createElementVNode("div", _hoisted_113, [
                                        _createElementVNode("p", {
                                          class: "font-black truncate cursor-pointer",
                                          onClick: ($event: any) => (openDetailImg(x.documentFileUrl))
                                        }, _toDisplayString(x.documentFileUrl.name ? shortenFileName(x.documentFileUrl.name) : shortenFileName(x.documentFileUrl)), 9, _hoisted_114)
                                      ]),
                                      (!x.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                            _createVNode(_unref(Popper), {
                                              arrow: "",
                                              hover: "",
                                              placement: "bottom",
                                              content: "Hapus File Dokumen"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("i", {
                                                  class: "pi pi-times font-bold color-danger text-sm cursor-pointer",
                                                  onClick: ($event: any) => (x.documentFileUrl = '')
                                                }, null, 8, _hoisted_116)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_117, "Tidak ada dokumen syarat tambahan"))
              ])
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onBack()))
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode("Kembali")
                ])),
                _: 1,
                __: [24]
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                class: "btn-primary mr-1",
                disabled: (meta.valid && false)
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createTextVNode("Simpan")
                ])),
                _: 2,
                __: [25]
              }, 1032, ["disabled"])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"])
      ]))
    : _createCommentVNode("", true)
}
}

})